import { gql } from 'graphql-tag';

export const GET_REVERSE_CHARGE_TAX_ACCOUNT_RATES = gql`
  query Idf69f9e3e7e7fd646cf6240acfee7dc39($companyId: ID!) {
    __typename
  }
`;
